import InitError from './Init'

class NotFound extends InitError {
  status = 404
  name = 'NotFound'
}

export default NotFound
